import { Avatar, Box, Typography } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import type { UserDashboardDataType } from '../../../types/userDashboardTypes';

type PropsType = {
  profile: UserDashboardDataType['profile'];
};

const UserProfileHeader = ({ profile }: PropsType) => {
  const fullName = `${profile.firstName} ${profile.lastName}`;
  const initials = `${profile.firstName.charAt(0)}${profile.lastName.charAt(0)}`;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <Avatar
        src={profile.avatarUrl ?? undefined}
        sx={{
          width: 56,
          height: 56,
          bgcolor: '#CAF0F8',
          color: '#0077B6',
        }}
      >
        {profile.avatarUrl ? null : initials || <PersonOutlineIcon />}
      </Avatar>
      <Box>
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 700,
            color: '#111827',
            lineHeight: 1.3,
          }}
        >
          {fullName}
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            color: '#6B7280',
            mt: 0.25,
          }}
        >
          {profile.email}
        </Typography>
      </Box>
    </Box>
  );
};

export default UserProfileHeader;
